 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780253063779_COVER from '@/components/text/9780253063779_Cover'
 import TEXT9780253063779_HALFTITLE from '@/components/text/9780253063779_Halftitle'
 import TEXT9780253063779_TITLE from '@/components/text/9780253063779_Title'
 import TEXT9780253063779_COPYRIGHT from '@/components/text/9780253063779_Copyright'
 import TEXT9780253063779_CONTENTS from '@/components/text/9780253063779_Contents'
 import TEXT9780253063779_PREFACE from '@/components/text/9780253063779_Preface'
 import TEXT9780253063779_HALFTITLE01 from '@/components/text/9780253063779_Halftitle01'
 import TEXT9780253063779_CHAPTER01 from '@/components/text/9780253063779_Chapter01'
 import TEXT9780253063779_CHAPTER02 from '@/components/text/9780253063779_Chapter02'
 import TEXT9780253063779_CHAPTER03 from '@/components/text/9780253063779_Chapter03'
 import TEXT9780253063779_CHAPTER04 from '@/components/text/9780253063779_Chapter04'
 import TEXT9780253063779_CHAPTER05 from '@/components/text/9780253063779_Chapter05'
 import TEXT9780253063779_CHAPTER06 from '@/components/text/9780253063779_Chapter06'
 import TEXT9780253063779_CHAPTER07 from '@/components/text/9780253063779_Chapter07'
 import TEXT9780253063779_CHAPTER08 from '@/components/text/9780253063779_Chapter08'
 import TEXT9780253063779_CONCLUSION from '@/components/text/9780253063779_Conclusion'
 import TEXT9780253063779_INDEX from '@/components/text/9780253063779_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780253063779_Contents",
 			"name" : "text/9780253063779_Contents",
 			"component" : TEXT9780253063779_CONTENTS
 		},
 		{
 			"path" : "/text/9780253063779_Preface",
 			"name" : "text/9780253063779_Preface",
 			"component" : TEXT9780253063779_PREFACE
 		},
 		{
 			"path" : "/text/9780253063779_Halftitle01",
 			"name" : "text/9780253063779_Halftitle01",
 			"component" : TEXT9780253063779_HALFTITLE01
 		},
 		{
 			"path" : "/text/9780253063779_Chapter01",
 			"name" : "text/9780253063779_Chapter01",
 			"component" : TEXT9780253063779_CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js